//渲染模板src:模板ID target:页面容器ID data:渲染数据 type:渲染方式
var EJS = require("./ejs");
var $ = require("jquery");

function renderHtml(src, target, data, type) {
  console.log('renderHtml====>', src);
  type = type || "all";
  data = data || {};
  var tmpl = $(src).innerText || $(src)[0].innerText || $(src)[0].innerHTML;
  tmpl = tmpl.replace(/\<\%\=\s*include\((.*?)\)\s*\%\>/g, function (a, b) {
    b = b.replace(/'|"/g, '');
    return $(b).innerText || $(b)[0].innerText || $(b)[0].innerHTML;
  });
  var obj = new EJS({
    text: tmpl
  });
  var html = obj.render(data);
  try {
    var func = new Function('a', 'b', '$(a).html(b)');
    func(target, html);
  } catch (error) {
    console.log('new Function: 报错');
    console.log(error);
  }
}

module.exports = {
  renderHtml: renderHtml
};


/*****************
 ** WEBPACK FOOTER
 ** ./utils/index.js
 ** module id = 16
 ** module chunks = 1 2 12
 **/